import {Component, OnDestroy, OnInit, ViewChild} from '@angular/core';
import {Observable, Subscription} from 'rxjs';
import {Store} from '@ngrx/store';
import {AppState, selectAuthState, selectDoctorState} from '../../../../store/app.states';
import {DoctorService} from '../../../../services/doctor.service';
import {Chart} from 'chart.js';
import {MatTableDataSource} from '@angular/material/table';
import {Patient} from '../../../../model/user/Patient';
import {MatPaginator, PageEvent} from '@angular/material/paginator';
import {Router} from '@angular/router';

@Component({
    selector: 'app-bar-chart-stable-unstable-gender-crohn',
    templateUrl: './bar-chart-stable-unstable-gender-crohn.component.html',
    styleUrls: ['./bar-chart-stable-unstable-gender-crohn.component.css']
})

export class BarChartStableUnstableGenderCrohnComponent implements OnInit, OnDestroy {
  getAuthState: Observable<any>;
  getDoctorState: Observable<any>;
  isAuthenticated: boolean;
  user = null;
  errorMessage = null;
  subscription: Subscription;
  subscription1: Subscription;
  // ******************************************************************************************************************
  // bar chart dei pazienti globali malati in miglioramento, in peggioramento, stabili, per genere
  // ******************************************************************************************************************
  // bar chart arrays
  remissione = [];
  attivitaLieve = [];
  attivitaModerata = [];
  attivitaGrave = [];
  // other arrays
  stabiliLieveUomo = 0;
  stabiliModerataUomo = 0;
  stabiliGraveUomo = 0;
  stabiliRemissioneUomo = 0;
  instabiliMiglLieveUomo = 0;
  instabiliMiglModerataUomo = 0;
  instabiliMiglGraveUomo = 0;
  instabiliPegLieveUomo = 0;
  instabiliPegModerataUomo = 0;
  instabiliPegGraveUomo = 0;
  instabiliMiglRemissioneUomo = 0;
  instabiliPegRemissioneUomo = 0;
  
  stabiliLieveDonna = 0;
  stabiliModerataDonna = 0;
  stabiliGraveDonna = 0;
  stabiliRemissioneDonna = 0;
  instabiliMiglLieveDonna = 0;
  instabiliMiglModerataDonna = 0;
  instabiliMiglGraveDonna = 0;
  instabiliPegLieveDonna = 0;
  instabiliPegModerataDonna = 0;
  instabiliPegGraveDonna = 0;
  instabiliMiglRemissioneDonna = 0;
  instabiliPegRemissioneDonna = 0;
  // elements for chart
  canvas: any;
  ctx: any;
  myChartStableUnstableCrohnGender: Chart;
  // ******************************************************************************************************************
  // bar chart
  // ******************************************************************************************************************
  public barChartLabelsGlobal = ['UOMO-STABILI','UOMO-IN MIGLIORAMENTO','UOMO-IN PEGGIORAMENTO',
  'DONNA-STABILI','DONNA-IN MIGLIORAMENTO','DONNA-IN PEGGIORAMENTO'];
  public barChartTypeGlobal = 'horizontalBar';
  public barChartLegendGlobal = true;
  public barChartDataGlobal = [
    {
      data: this.attivitaLieve,
      barThickness: 20,
      backgroundColor: ['#ffd491', '#ffd491', '#ffd491','#ffd491', '#ffd491', '#ffd491'],
      hoverBackgroundColor: ['#ef8800', '#ef8800', '#ef8800','#ef8800', '#ef8800', '#ef8800'],
      label: 'ATTIVITA LIEVE',
      datalabels: {
        color: 'white', // Color for percentage value
      }
    },
    {
        data: this.attivitaModerata,
        barThickness: 20,
        backgroundColor: ['#ffb769', '#ffb769', '#ffb769','#ffb769', '#ffb769', '#ffb769'],
        hoverBackgroundColor: ['#ff7b5a', '#ff7b5a', '#ff7b5a','#ff7b5a', '#ff7b5a', '#ff7b5a'],
        label: 'ATTIVITA MODERATA',
        datalabels: {
          color: 'white', // Color for percentage value
        }
      },
      {
        data: this.attivitaGrave,
        barThickness: 20,
        backgroundColor: ['#ff5232', '#ff5232', '#ff5232','#ff5232', '#ff5232', '#ff5232'],
        hoverBackgroundColor: ['#d11507', '#d11507', '#d11507','#d11507', '#d11507', '#d11507'],
        label: 'ATTIVITA GRAVE',
        datalabels: {
          color: 'white', // Color for percentage value
        }
      },
    {
      data: this.remissione,
      barThickness: 20,  // number (pixels) or 'flex'
      backgroundColor: ['#a1e19e', '#a1e19e', '#a1e19e','#a1e19e', '#a1e19e', '#a1e19e'],
      hoverBackgroundColor: ['#03c03c', '#03c03c', '#03c03c','#03c03c', '#03c03c', '#03c03c'],
      label: 'REMISSIONE',
      datalabels: {
        color: 'white' // Color for percentage value}
      }
    }
    ];
  // table
  dataSource = new MatTableDataSource();
  headElements = ['name', 'surname', 'card', 'questionnaire', 'email', 'chat'];
  totalSize = 0;
  // TABELLE DISPONIBILI
  isHovered = false;
  // paginator della tabella
  public pageSize = 5;
  public currentPage = 0;
  public tasks: any[];
  @ViewChild(MatPaginator, {static: false}) set matPaginator(paginator: MatPaginator) {
    if (paginator) {
      paginator._intl.itemsPerPageLabel = 'Pazienti per pagina';
      paginator._intl.previousPageLabel = 'Pagina precedente';
      paginator._intl.nextPageLabel = 'Pagina successiva';
    }
  }

  constructor(private store: Store<AppState>,
              private doctorService: DoctorService,
              private router: Router) {
    this.getAuthState = this.store.select(selectAuthState);
    this.getDoctorState = this.store.select(selectDoctorState);
  }
  ngOnInit(): void {
    this.subscription1 = this.getAuthState.subscribe((state) => {
      this.isAuthenticated = state.isAuthenticated;
      this.user = JSON.parse(localStorage.getItem('user'));
      this.errorMessage = state.errorMessage;
      this.retrieveGenderStableAndUnstable();
    });
  }
  ngOnDestroy(): void {
    this.subscription.unsubscribe();
    this.subscription1.unsubscribe();
  }

  retrieveGenderStableAndUnstable(){
    this.subscription = this.doctorService.getCrohnStableAndUnstableGender().subscribe( data => {
      let keys = Object.keys(data);
      //console.log("Keys: " + keys);
      let values = Object.values(data);
      for (let i in keys){
        var key = keys[i];
        //console.log("Key..." + key);
        if (key === 'StabiliRemissioneUomo'){
          this.stabiliRemissioneUomo = values[i];
        }
        else if (key === 'InstabiliMiglLieveDonna'){
          this.instabiliMiglLieveDonna = values[i];
        }
        else if (key === 'InstabiliMiglModerataDonna'){
          this.instabiliMiglModerataDonna = values[i];
        }
        else if (key === 'InstabiliMiglGraveDonna'){
            this.instabiliMiglGraveDonna = values[i];
        }
        else if (key === 'StabiliRemissioneDonna'){
          this.stabiliRemissioneDonna = values[i];
        }
        else if (key === 'InstabiliPegLieveDonna'){
          this.instabiliPegLieveDonna = values[i];
        }
        else if (key === 'InstabiliPegModerataDonna'){
            this.instabiliPegModerataDonna = values[i];
        }
        else if (key === 'InstabiliPegGraveDonna'){
            this.instabiliPegGraveDonna = values[i];
        }
        else if (key === 'InstabiliPegRemissioneDonna'){
          this.instabiliPegRemissioneDonna = values[i];
        }
        else if (key === 'InstabiliMiglRemissioneDonna'){
          this.instabiliMiglRemissioneDonna = values[i];
        }
        else if (key === 'InstabiliPegRemissioneUomo'){
          this.instabiliPegRemissioneUomo = values[i];
        }
        else if (key === 'InstabiliPegLieveUomo'){
          this.instabiliPegLieveUomo = values[i];
        }
        else if (key === 'InstabiliPegModerataUomo'){
            this.instabiliPegModerataUomo = values[i];
        }
        else if (key === 'InstabiliPegGraveUomo'){
            this.instabiliPegGraveUomo = values[i];
        }
        else if (key === 'StabiliLieveUomo'){
          this.stabiliLieveUomo = values[i];
        }
        else if (key === 'StabiliModerataUomo'){
            this.stabiliModerataUomo = values[i];
        }
        else if (key === 'StabiliGraveUomo'){
            this.stabiliGraveUomo = values[i];
        }
        else if (key === 'InstabiliMiglRemissioneUomo'){
          this.instabiliMiglRemissioneUomo = values[i];
        }
        else if (key === 'StabiliLieveDonna'){
          this.stabiliLieveDonna = values[i];
        }
        else if (key === 'StabiliModerataDonna'){
            this.stabiliModerataDonna = values[i];
        }
        else if (key === 'StabiliGraveDonna'){
            this.stabiliGraveDonna = values[i];
        }
        else if (key === 'InstabiliMiglLieveUomo'){
          this.instabiliMiglLieveUomo = values[i];
        }
        else if (key === 'InstabiliMiglModerataUomo'){
            this.instabiliMiglModerataUomo = values[i];
        }
        else if (key === 'InstabiliMiglGraveUomo'){
            this.instabiliMiglGraveUomo = values[i];
        }
      }
      
      // riempio il vettore della categoria 'grave' in ordine stabili, miglioramento e peggioramento
      this.attivitaGrave.push(this.stabiliGraveUomo);
      this.attivitaGrave.push(this.instabiliMiglGraveUomo);
      this.attivitaGrave.push(this.instabiliPegGraveUomo);
      this.attivitaGrave.push(this.stabiliGraveDonna);
      this.attivitaGrave.push(this.instabiliMiglGraveDonna);
      this.attivitaGrave.push(this.instabiliPegGraveDonna);
      // riempio il vettore della categoria 'lieve' in ordine stabili, miglioramento e peggioramento
      this.attivitaLieve.push(this.stabiliLieveUomo);
      this.attivitaLieve.push(this.instabiliMiglLieveUomo);
      this.attivitaLieve.push(this.instabiliPegLieveUomo);
      this.attivitaLieve.push(this.stabiliLieveDonna);
      this.attivitaLieve.push(this.instabiliMiglLieveDonna);
      this.attivitaLieve.push(this.instabiliPegLieveDonna);
      // riempio il vettore della categoria 'moderata' in ordine stabili, miglioramento e peggioramento
      this.attivitaModerata.push(this.stabiliModerataUomo);
      this.attivitaModerata.push(this.instabiliMiglModerataUomo);
      this.attivitaModerata.push(this.instabiliPegModerataUomo);
      this.attivitaModerata.push(this.stabiliModerataDonna);
      this.attivitaModerata.push(this.instabiliMiglModerataDonna);
      this.attivitaModerata.push(this.instabiliPegModerataDonna);
      // riempio il vettore della categoria 'remissione' in ordine, stabili, miglioramento e peggioramento
      this.remissione.push(this.stabiliRemissioneUomo);
      this.remissione.push(this.instabiliMiglRemissioneUomo);
      this.remissione.push(this.instabiliPegRemissioneUomo);
      this.remissione.push(this.stabiliRemissioneDonna);
      this.remissione.push(this.instabiliMiglRemissioneDonna);
      this.remissione.push(this.instabiliPegRemissioneDonna);
      console.log("Remissione: " + this.remissione);
      this.canvasSetting();
    }, error => {
        if (error.status === 500) {
          localStorage.setItem('expirationTime', '0');
          console.log('SESSIONE SCADUTA');
          location.reload();
        }
      });
  }

  canvasSetting() {
    this.canvas = document.getElementById('myChartStableUnstableCrohnGender') as HTMLCanvasElement;
    this.ctx = this.canvas.getContext('2d');
    this.myChartStableUnstableCrohnGender = new Chart(this.ctx, {
      type: this.barChartTypeGlobal,
      data: {
        labels: this.barChartLabelsGlobal,
        datasets: this.barChartDataGlobal,
      },
      options: {
        maintainAspectRatio: true,
        responsive: true,
        onHover: (event) => {
          if (this.myChartStableUnstableCrohnGender.getElementAtEvent(event).length > 0) {
            if (this.myChartStableUnstableCrohnGender.getElementAtEvent(event)[0]['_model'].datasetLabel === 'ATTIVITA LIEVE' || 
              this.myChartStableUnstableCrohnGender.getElementAtEvent(event)[0]['_model'].datasetLabel === 'ATTIVITA MODERATA' ||
              this.myChartStableUnstableCrohnGender.getElementAtEvent(event)[0]['_model'].datasetLabel === 'ATTIVITA GRAVE' ||
              this.myChartStableUnstableCrohnGender.getElementAtEvent(event)[0]['_model'].datasetLabel === 'REMISSIONE') {
              this.setHoverVariable();
            } else {
              this.unsetHoverVariable();
            }
          }
        },
        scales: {
          xAxes: [{
            display: true,
            stacked: true,
            ticks: {
              fontSize: 12,
              fontStyle: 'bold',
              fontFamily: 'Helvetica',
              fontColor: '#006192'
            }
          }],
          yAxes: [{
            display: true,
            stacked: true,
            ticks: {
              fontSize: 12,
              fontStyle: 'bold',
              fontFamily: 'Helvetica',
              fontColor: '#006192'
            }
          }],
        },
        legend: {
          onHover: (event: MouseEvent, legendItem: Chart.ChartLegendLabelItem) => {
            if (legendItem.text.length > 0 && (legendItem.text === 'ATTIVITA LIEVE' || legendItem.text === 'ATTIVITA MODERATA'
            || legendItem.text === 'ATTIVITA GRAVE' || legendItem.text === 'REMISSIONE')) {
              this.setHoverVariable();
            } else {
              this.unsetHoverVariable();
            }
          },
          display: true,
          position: 'top',
          align: 'center',
          labels: {
            usePointStyle: true,
            fontColor: '#006192',
            fontSize: 18,
            fontFamily: 'Helvetica',
          }
        },
        tooltips: {
          // content: '{pathology}: {number}',
          backgroundColor: '#1c1c1c',
          bodyFontSize: 18,
          titleFontSize: 18,
          cornerRadius: 5,
          caretPadding: 10
        },
        title: {
          display: true,
          text: 'Numero di pazienti',
          fontColor: '#006192',
          fontSize: 20,
          fontFamily: 'Helvetica',
        },
        hover: {
          mode: 'nearest',
          intersect: true
        }
      }
    });
    }

    // pagination della tabella di stabili recidiva patients
  // paginazione effettuata manualmente
  getPagination(data) {
    console.log(data);
    this.dataSource = new MatTableDataSource<Patient>();
    // this.dataSource.data = data;
    this.tasks = data;
    this.currentPage = 0; // così che appena si seleziona il grafico appaia la giusta pagina con le prime persone
    this.totalSize = this.tasks.length;
    this.iterator(); // iterator sistema i nomi alla pagina corretta
  }
  handlePage(event?: PageEvent) {
    this.currentPage = event.pageIndex;
    this.pageSize = event.pageSize;
    this.iterator();
  }
  private iterator() {
    const end = (this.currentPage + 1) * this.pageSize;
    const start = this.currentPage * this.pageSize;
    this.dataSource.data = this.tasks.slice(start, end);
  }
  // set hovered variable
  setHoverVariable(): void {
    this.isHovered = true;
  }
  // unset hovered variable
  unsetHoverVariable(): void {
    this.isHovered = false;
  }
  openPanel(patient) {
    this.router.navigateByUrl('/patient-panel/' + patient.ssn + '/general-status');
  }
  openQuestionnaire(patient) {
    this.router.navigateByUrl('/patient-questionnaires-show/' + patient.ssn + '/patient-sccai' + '/general-status');
  }
  openChat(patient) {
    this.router.navigateByUrl('/doctor-chat/' + patient.ssn + '/general-status');
  }
  async delay(ms: number) {
    await new Promise(resolve => setTimeout(() => resolve(), ms)).then(() => console.log('fired'));
  }

}